// Constants
import SPC from "components/Stacker/constants/SearchPageConstants"
import TC from "components/Stacker/constants/TrackingConstants"

// Utils
import ApiUtils from "components/Stacker/api"

import {
  addtoDataLayer,
  getDataLayer,
} from "components/Stacker/utils/DataLayer"
import { getDY_SR } from "stackerConfig"
import { shallowEqual } from "react-redux"
// import { change, initialize } from "redux-form";
// import FRMC from 'components/Stacker/config/FormConfig';

// const syncReduxWithLocationSearch = async (dispatch, getState) => {
// 	// Band-aid to restore facet loading, broken in portability
// 	// Loop over the fq values in search
// 	// Check if they match facet data
// 	// Dispatch redux form changes for selected facets
// 	const state = getState()
// 	const windowQS = window.location.search.startsWith('?')
// 		? window.location.search.slice(1)
// 		: window.location.search
// 	const queryObj = queryString.parse(windowQS)
// 	const facets = state.search?.data?.facets || []
// 	const fq = (Array.isArray(queryObj.fq) && queryObj.fq)
// 		|| [queryObj.fq].filter(x => x)

// 	// await new Promise((res) => requestAnimationFrame(res))

// 	let filterObjectComposite = fq.map(searchFilter => {
// 		const facetPairs = // Flatten the facet[]values[] to facetvalue[]
// 			facets.map(f => f.values.map(v => ({ facet: f, value: v })))
// 			.flat()

// 		const exactPair = facetPairs.find(p => `${p.facet.code}:"${p.value.code}"` === searchFilter)
// 		if(exactPair) {
// 			const exactPayload = {[`${exactPair.facet.code}:"${exactPair.value.code}"`]: true}
// 			return exactPayload
// 		}

// 		const searchOptions = searchFilter.split(':')[1].split(' OR ')
// 			.map(o => ({
// 				code: searchFilter.split(':')[0],
// 				expression: o
// 			}))
// 		const filtersToInit = searchOptions.map(so => {
// 			const facetPair = facetPairs.find(p => `${p.facet.code}:"${p.value.code}"` === `${so.code}:${so.expression}`)
// 			if(facetPair) {
// 				dispatch(toggleFilterItem(searchFilter))
// 				return [searchFilter, true]
// 			}
// 			return false
// 		})
// 			.concat(exactPair ? [exactPair, true] : [])
// 			.filter(x => x)
// 		const filterObject = Object.fromEntries(filtersToInit)
// 		return filterObject
// 	}).reduce((a,b) => ({...a, ...b}), {})

// 	dispatch(initialize(FRMC.FORM_SEARCH_FILTER, filterObjectComposite))
// 	dispatch(synchronizeSearchFilters(filterObjectComposite))
// }

// const synchronizeSearchFilters = (filterObject) => (dispatch, getState) => {
// 	// one entry per category
// 	const filterObjectKeys = Object.keys(filterObject)
// 	const filterNames = filterObjectKeys.map(k => [
// 		k.split(':')[0],
// 		k.split(':')[1].split(' OR ')
// 			.map(opt => opt) //opt.substring(1, opt.length - 1)) // chop off the "" surrounding the value :(
// 	])

// 	// What the items are, but not whether they are selected
// 	const selectedFilterItems = Object.fromEntries(filterNames)

// 	const codeValues = filterObjectKeys.map(k =>
// 		k.split(':')[1]
// 		 .split(' OR ')
// 		 .map(opt => ({ code: k.split(':')[0], option: opt, value: filterObject[k] }))
// 	).flat()
// 		.map(co => [`${co.code}:${co.option}`, co.value])
// 	// Whether they are selected or not
// 	const selectedFilterItemsFromServer = Object.fromEntries(codeValues)

// 	// What is applied to the query
// 	const filterString = filterNames.map(fn =>
// 		`${fn[0]}:${fn[1].map(x => `${x}`).join(' OR ')}`
// 	)

// 	// Used to compare mutations (ugh)
// 	const lastApplied = new Date().toLocaleString() //whenever??? ie MM/D/YYYY, HH:MM:SS PM

// 	dispatch({
// 		type: "searchActions/SYNCHRONIZE_SEARCH_FILTERS",
// 		payload: {
// 			selectedFilterItems,
// 			selectedFilterItemsFromServer,
// 			filterString,
// 			lastApplied
// 		}
// 	})
// }

const updateDataLayer = (options) => {
  const {
    productView,
    facetFilters = {},
    pagination: { totalResults },
    pageInfo = {},
  } = options
  addtoDataLayer(TC.LAYER_PRODUCT_VIEW, productView)

  const { facetFilter: { items: previousItems = [] } = {} } = getDataLayer()

  const { items = [] } = facetFilters

  addtoDataLayer(TC.LAYER_FACET_FILTER, facetFilters)

  if (pageInfo && Object.keys(pageInfo).length) {
    addtoDataLayer(TC.LAYER_PAGE, pageInfo)
  }
  // Checking Facet filter length to fire ensighten when we have applied filters
  // if (
  //   items.length &&
  //   previousItems.length !== 0 &&
  //   items.length > previousItems.length
  // ) {
  // }

  addtoDataLayer(TC.LAYER_PRODUCT_COUNT, totalResults)
}

export const getInlinePromos =
  ({ inlinePromos }) =>
  (dispatch, getState) => {
    Promise.all(
      inlinePromos.map((promo) => {
        return ApiUtils.makeAjaxRequest({
          url: `${promo.promoPath}.html`,
          type: "html",
        })
      })
    ).then((promos) => {
      const populatedInlinePromos = inlinePromos.map((promo, index) => {
        promo.data = promos[index]
        return promo
      })
      dispatch({
        type: SPC.SEARCH_INLINE_PROMO_SUCCEED,
        payload: populatedInlinePromos,
      })
    })
  }

let lastSearch = null

export const getSearchResult =
  (queryParams, options, retailerId) => (dispatch, getState) => {
    const { isGiftGuideNavigation, isSearchPage, preloadedResponse } = options

    if (shallowEqual(queryParams, lastSearch)) {
      return
    }

    lastSearch = queryParams

    if (isSearchPage) {
      const suggest = {
        searchTerm: queryParams.q,
      }
      addtoDataLayer(TC.LAYER_TYPEAHEAD_SUGGEST, suggest)
    }

    if (typeof preloadedResponse === "undefined") {
      dispatch({
        type: SPC.SEARCH_START,
        payload: { options },
      })
      queryParams.requestType = "search"
      if (window.location.search.includes("stacker-mock=bracelets")) {
        queryParams.mock = "bracelets"
      } else if (window.location.search.includes("stacker-mock=amulets")) {
        queryParams.mock = "amulets"
      } else if (window.location.search.includes("stacker-mock=necklaces")) {
        queryParams.mock = "necklaces"
      }
      ApiUtils.makeAjaxRequest(
        {
          // url: '/.api.plp.getProductsList.json',
          url: `v1/retailer/${retailerId}/productlist`,
          queryParams,
        },
        (res) => {
          if (res.status === ApiUtils.RESPONSE_ERROR) {
            res.searchPromoPath = ""
            dispatch({
              type: SPC.SEARCH_NO_RESULT_FOUND,
              payload: res.searchPromoPath,
            })
            if (isSearchPage) {
              // fire TC.INTERNAL_SEARCH on entering Search param.
            }
          } else {
            /** start of the success results */
            console.log("success result searchactions")
            const { products, keywordRedirect: { redirectedUrl } = {} } = res

            const isProductsEmpty = !products.length
            if (redirectedUrl) {
              const { baseURL } = getDY_SR().config.global
              window.location.href = `${baseURL}${redirectedUrl}`
            } else {
              const {
                data: { products: previousProducts },
              } = getState().search
              //	const previousProducts = getState().search.data.products;
              // if (res.pagination.totalResults === '0') {  // this was used for infinite Scroll check where the totalresulst will be 0,
              //	but due to sync between AEM and Hybris this key might hold a wrong value
              // thus below checking the new products received in API call and also if previous products are there or not for no search Results.
              if (isProductsEmpty && !previousProducts.length) {
                dispatch({
                  type: SPC.SEARCH_NO_RESULT_FOUND,
                  payload: res.searchPromoPath,
                })
                updateDataLayer(res)
                if (isSearchPage) {
                  // fire TC.INTERNAL_SEARCH on entering Search param.
                }
              } else {
                if (res.inlinePromos.length > 0) {
                  dispatch(getInlinePromos(res))
                }

                const { isSortFilterApplied } = options

                delete options.isSortFilterApplied

                dispatch({
                  type: SPC.SEARCH_SUCCEED,
                  payload: {
                    res,
                    queryParams,
                    options,
                  },
                })

                updateDataLayer(res)

                if (isGiftGuideNavigation) {
                  // firing event when gift guide navigation btn is clicked
                }

                if (
                  isSearchPage &&
                  res.pagination.currentPage === "0" &&
                  !isSortFilterApplied
                ) {
                  // fire TC.INTERNAL_SEARCH on entering Search param.
                }

                //dispatch(syncReduxWithLocationSearch)
              }
            }
          }
          /** End of the search results */
        }
        // err => {
        // 	dispatch({
        // 		type: SPC.SEARCH_FAILED,
        // 		payload: {
        // 			productID: queryParams,
        // 			err
        // 		}
        // 	});
        // }
      )
    } else {
      // typeof preloadedResponse !== 'undefined':
      if (
        preloadedResponse.inlinePromos &&
        preloadedResponse.inlinePromos.length > 0
      ) {
        dispatch(getInlinePromos(preloadedResponse))
      }

      if (
        typeof preloadedResponse === "object" &&
        ({}.propertyIsEnumerable.call(preloadedResponse, "products") ||
          {}.propertyIsEnumerable.call(preloadedResponse, "pagination") ||
          {}.propertyIsEnumerable.call(preloadedResponse, "productView"))
      ) {
        dispatch({
          type: SPC.SEARCH_SUCCEED,
          payload: {
            res: preloadedResponse,
            queryParams,
            options,
          },
        })
      }

      updateDataLayer(preloadedResponse)
    }
  }

export function toogleFilterCategory(name, status) {
  if (typeof status !== "undefined") {
    if (status) {
      return {
        type: SPC.SEARCH_FILTER_CATEGORY_SHOW,
        payload: name,
      }
    }

    return {
      type: SPC.SEARCH_FILTER_CATEGORY_HIDE,
    }
  }

  return {
    type: SPC.SEARCH_FILTER_CATEGORY_TOOGLED,
    payload: name,
  }
}

export function toggleFilterView(status) {
  return {
    type: SPC.SEARCH_FILTER_VIEW_TOOGLED,
    payload: status,
  }
}

export function toggleFilterItem(query) {
  return {
    type: SPC.SEARCH_FILTER_ITEM_TOOGLED,
    payload: query,
  }
}

export function applyFilters() {
  return {
    type: SPC.SEARCH_FILTER_APPLY_CLICKED,
  }
}

export function clearFilters(subFilter) {
  return {
    type: subFilter
      ? SPC.SEARCH_FILTER_CLEAR_SELECTED
      : SPC.SEARCH_FILTER_CLEAR_ALL,
    payload: subFilter,
  }
}

export function toggleSortView(status) {
  if (typeof status !== "undefined") {
    return {
      type: status ? SPC.SORT_VIEW_SHOW : SPC.SORT_VIEW_HIDE,
    }
  }

  return {
    type: SPC.SORT_VIEW_TOOGLED,
    payload: status,
  }
}

export function setCurrentSort(sortKey) {
  return {
    type: SPC.SEARCH_SORT_SET_SELECTION,
    payload: sortKey,
  }
}

export const getSearchPromo = (searchPromoPath) => (dispatch, getState) => {
  ApiUtils.makeAjaxRequest(
    {
      url: `${searchPromoPath}.html`,
      type: "html",
    },
    (res) => {
      dispatch({
        type: SPC.SEARCH_PROMO_SUCCEED,
        payload: {
          res,
        },
      })
    },
    (err) => {
      dispatch({
        type: SPC.SEARCH_PROMO_FAILED,
        payload: {
          err,
        },
      })
    }
  )
}

export function expandFilterCategory(filterCode) {
  return {
    type: SPC.SEARCH_SEE_ALL_FILTERS,
    payload: filterCode,
  }
}

export function setActiveHolidayTab(tabIndex) {
  return {
    type: SPC.SET_HOLIDAY_TAB,
    payload: tabIndex,
  }
}
